import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import React from "react";
import {
  formatDateIntoDMYToDisplay,
  gethoursAndMins,
  getPlanManagedBy,
  textTruncate,
  truncateTextReporting,
} from "Utils/utils";
import { formatCaseNoteSupportItemFullLabel } from "Utils/caseNoteSupportItem";
import { DELIVERED_SERVICE_STATUS_OPTIONS } from "Constants/constant";
import PopoverContainer from "components/common/Popover/PopoverContainer";
import moment from "moment";
import useCareLabels from "hooks/useCareLabels";
import CaseNoteHistoryNoteCell from "components/ServiceProvider/Participant/CaseNotes/CaseNoteHistoryNoteCell";

const CaseNotesTable = ({
  flipSort,
  sortBy,
  sortDescending,
  reportList,
  loader,
  participantNameLabel: participantNameLabelProp,
  lineItemLabel: lineItemLabelProp,
}) => {
  const { participantNameLabel: participantNameLabelDefault, lineItemLabel: lineItemLabelDefault } =
    useCareLabels();
  const participantNameLabel =
    participantNameLabelProp ?? participantNameLabelDefault;
  const lineItemLabel = lineItemLabelProp ?? lineItemLabelDefault;
  return (
    <div className='overflow-x-auto custom-scroll'>
      <table className='border min-w-full divide-y divide-gray-300'>
        <thead
          // style={{ top: "130px" }}
          className='bg-gray-50 sticky z-[5]'
        >
          <tr>
            <TableHeader isSort={false} label={participantNameLabel} cssClass='bg-blue-50 pl-4'  />
            <TableHeader isSort={false} label={"Funding Contract ID"} cssClass='bg-blue-50' />
            <TableHeader isSort={false} label={"Delivery Serial No."} cssClass='bg-blue-50'/>

            <TableHeader isSort={false} label={lineItemLabel} cssClass='bg-blue-50' />

            <TableHeader isSort={false} label={"Created By"} cssClass='bg-blue-50' />

            <TableHeader isSort={false} label={"Created Date"} cssClass='bg-blue-50' />

            <TableHeader isSort={false} label={"Mgmt Style"} cssClass='bg-blue-50' />

            <TableHeader isSort={false} label={"Delivered Date"} cssClass='bg-blue-50' />

            <TableHeader isSort={false} label={"Hours"} cssClass='bg-blue-50' />
            <TableHeader isSort={false} label={"Bill Type"} cssClass='bg-blue-50' />
            <TableHeader isSort={false} label={"Rate"} cssClass='bg-blue-50' />
            <TableHeader isSort={false} label={"Delivered Amount"} cssClass='bg-blue-50' />
            <TableHeader isSort={false} label={"Status"} cssClass='bg-blue-50' />
            <TableHeader isSort={false} label={"Notes"} cssClass='bg-blue-50' />
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
          {loader ? (
            <tr className='bg-white'>
              <td colSpan={14} className='py-6 text-center bg-white'>
                <div
                  className={`flex flex-col w-full min-h-screen bg-white items-start  justify-center`}
                >
                  <CircularLoader
                    classes='flex justify-center items-center'
                    classloader='loader-l'
                  />
                </div>
              </td>
            </tr>
          ) : reportList !== null && reportList?.casenotes?.data?.length > 0 ? (
            reportList?.casenotes?.data?.map((caseNoteItem, index) => {
              const supportDisplay =
                caseNoteItem?.support_item_label ??
                formatCaseNoteSupportItemFullLabel(
                  caseNoteItem?.support_item_number,
                  caseNoteItem?.support_item_name,
                  caseNoteItem?.claim_type
                );
              return (
              <tr key={index} className='even:bg-white odd:bg-gray-50'>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate capitalize'>
                  {`${caseNoteItem?.participant?.first_name} ${caseNoteItem?.participant?.last_name}`}
                </td>
                <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                  {caseNoteItem?.funding_contract_id ?? "-"}
                </td>
                <td className='whitespace-nowrap px-2 py-4 text-sm text-gray-500'>
                  {caseNoteItem.delivered_service_number || "-"}
                </td>
                <td
                
                  className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate'
                >
                    <div
                    className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                    style={{
                      maxWidth: "100px",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {supportDisplay ? (
                      <PopoverContainer
                        cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                        itemComponent={() => {}}
                        toolTip={`${supportDisplay}`}
                      >
                        <span>
                          {truncateTextReporting(supportDisplay)}
                        </span>
                      </PopoverContainer>
                    ) : (
                      "-"
                    )}
                  </div>
                  {/* {textTruncate(caseNoteItem?.support_item_name, 40, 39)} */}
                </td>
                <td
              
                  className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate capitalize'
                >
                     <div
                    className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                    style={{
                      maxWidth: "100px",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {caseNoteItem?.created_by  ? (
                      <PopoverContainer
                        cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                        itemComponent={() => {}}
                        toolTip={`${caseNoteItem?.created_by}`}
                      >
                        <span>
                          {truncateTextReporting(caseNoteItem?.created_by)}
                        </span>
                      </PopoverContainer>
                    ) : (
                      "-"
                    )}
                  </div>
                </td>

                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate capitalize'>
                  {caseNoteItem?.created_at? moment(caseNoteItem?.created_at).format("DD/MM/YYYY") : "-"}
                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate'>
                  {getPlanManagedBy(caseNoteItem?.manged_by)}
                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate'>
            
                  {caseNoteItem?.delivered_date? moment(caseNoteItem?.delivered_date).format("DD/MM/YYYY") : "-"}

                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate'>
                  {gethoursAndMins(caseNoteItem?.hours, caseNoteItem?.mints)}
                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm'>
                  {(caseNoteItem?.bill_types === "Billable" ||
                  caseNoteItem?.bill_types === "billable_hours" ||
                  caseNoteItem?.bill_types === "true") ? (
                    <span className='inline-flex rounded-full bg-green-100 px-2 py-0.5 font-medium text-green-800'>
                      Billable
                    </span>
                  ) : (
                    <span className='inline-flex rounded-full bg-gray-100 px-2 py-0.5 font-medium text-gray-700'>
                      Non-Billable
                    </span>
                  )}
                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate'>
                  {`$${caseNoteItem?.original_rate}`}
                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate'>
                  {`$${caseNoteItem?.total_amount}`}
                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate capitalize'>
                  {caseNoteItem?.status === null
                    ? DELIVERED_SERVICE_STATUS_OPTIONS.find((arr) => {
                        return caseNoteItem?.invoice_status === arr.value;
                      }).label
                    : DELIVERED_SERVICE_STATUS_OPTIONS.find((arr) => {
                        return caseNoteItem?.status === arr?.value;
                      }).label}
                </td>
                <td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500 truncate w-[20%]'>
                  <div
                    className='font-medium overflow-hidden text-gray-900'
                    style={{ maxWidth: "100px" }}
                  >
                    <CaseNoteHistoryNoteCell
                      row={caseNoteItem}
                      caseNoteApiModule='cos'
                      displayMaxLength={10}
                      className='truncate capitalize'
                    />
                  </div>
                </td>
              </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={14} className='py-6 text-center text-red-600'>
                No data found. Please adjust your filters to get relevant
                results
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CaseNotesTable;
